import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import * as policeSiren from "./components/police-siren";
import * as hardDiskDrive from "./components/hard-disk-drive";
import * as speech from "./components/speech";
import * as airCompressor from "./components/air-compressor";

const principle: Slide = {
  description:
    "Audible examples of real modulated sounds are given below along with their respective Fluctuation Strength (FS) and Roughness (R) values.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Police Siren" },
            { name: "Hard Disk Drive" },
            { name: "Speech" },
            { name: "Air Compressor" },
          ],
        },
      ],
      extraContent: [
        policeSiren.extraContent,
        hardDiskDrive.extraContent,
        speech.extraContent,
        airCompressor.extraContent,
      ],
      components: [policeSiren.components, hardDiskDrive.components, speech.components, airCompressor.components],
    },
  },
};

export default principle;
